// @core/api/endpoints/billing/list_ledger_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLedgerEntriesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List ledger entries
 * Returns ledger entries from the general ledger with optional filtering by account and date range. Shows the permanent record of all posted transactions.
 */
export async function ListLedgerEntries(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLedgerEntriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/ledger`;
  const requestOptions = options;
  return client.get<ListLedgerEntriesResponse>(requestPath, { ...requestOptions, params });
}
